export const ClientType = Object.freeze({
  PRIMARY: 1,
  SECONDARY: 2,
  EARLY_CHILDHOOD: 3,
  SEN: 4,
  P12: 5,
  ADULT_EDUCATION: 6,
  OSHC: 7,
  TA: 8,
  ADMINISTRATION: 9,
  GOVERNMENT: 10,
  INDEPENDENT: 11,
  COUNCIL: 12,
  KINDERGARTEN: 13,
  PRU: 14,
  K12: 15,
  MIDDLE_SCHOOL: 16,
  INTERMEDIATE: 17,
  ECE: 18,
  HOLIDAY_PROGRAM_OR_OSCAR: 65,
})
